import React, {useEffect} from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import QuizStatistics from './QuizStatistics';
import {Link, withRouter} from 'react-router-dom';
import {fetchQuiz} from '../../api';
import Modal from '../common/Modal';
import {isEmpty} from 'lodash/lang';
import {Check, Close as CloseIcon} from '@material-ui/icons';
import QuizResult from './QuizResult';
import {connect} from 'react-redux';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            <Box p={3}>{children}</Box>
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function QuizReports(props, context) {
    const {match: {params: {quizId}}} = props;
    const [value, setValue] = React.useState(0);
    const [quizData, setQuizData] = React.useState(null);
    const [questionData, setQuestionData] = React.useState(null);
    const [modalOpen, setModalOpen] = React.useState(false);
    const {router} = context;

    function handleChange(event, newValue) {
        setValue(newValue);
    }

    useEffect(() => {
        fetchQuiz(quizId).then(setQuizData);
    }, []);

    function getDetailedResults(userQuizId){
        router.history.push(`/quizzes/${userQuizId}/answers`);
    }

    function displayQuestionModal(questionRecordData){
        setQuestionData(questionRecordData);
        setModalOpen(true);
    }

    if (isEmpty(quizData)) {
        return null;
    }

    return (
        <>
            <Modal
                title=""
                onClose={() => setModalOpen(false)}
                open={modalOpen}
                fullWidth
            >
                {!isEmpty(questionData) && <>
                    <h3 color="primary"> Question Name: {questionData.record.name} </h3>
                    <div className="content-box width-100">
                        <div key={`question-panel-for-question-${questionData.id}`}>
                            <div >
                                <div className={'quiz-question-content question-container'}
                                    dangerouslySetInnerHTML={{__html: questionData.record.content}}/>
                                <ul className="ul-take-quiz">
                                    { questionData.record.answers.map((answer, questionAnswerIndex) => (
                                        <li key={`quiz-question-${questionAnswerIndex}`}>
                                            <div className="quiz-question-list-item-container">
                                                {answer.correct ? <Check className="quiz-check-green"/> :
                                                    <CloseIcon className="quiz-incorrect-label"/>}
                                                <div className={'quiz-question-content'}
                                                    dangerouslySetInnerHTML={{__html: answer.content}}/>
                                            </div>
                                        </li>
                                    ))
                                    }
                                </ul>
                                <hr/>
                            </div>
                        </div>
                    </div>
                </>}
            </Modal>
            <div className="content-box">
                <div className="navigation-history-container">
                    <Link to={'/quizzes'}>My Quizzes</Link> > Report {quizData ? `: ${quizData.name}` : ''}
                </div>
                <h2 className="section-header">
                    <div className="section-title">{quizData ? quizData.name : 'Quiz Reports'}</div>
                </h2>
                {/*<PDFShareButtons/>*/}
                <div>
                    <Paper square position="static" color="default" className="report-tab-bar">
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                        >
                            <Tab label="Quiz Stats"/>
                            <Tab label="Student Reports"/>
                        </Tabs>
                    </Paper>

                    <TabPanel index={0} value={value}>
                        <QuizStatistics quizId={quizId} showQuestionModal={displayQuestionModal}/>
                    </TabPanel>
                    <TabPanel index={1} value={value}>
                        <QuizResult
                            quizId={quizId}
                            historyAction={getDetailedResults}/>
                    </TabPanel>
                </div>
            </div>
        </>
    );
}

QuizReports.contextTypes = {
    router: PropTypes.object.isRequired
};

export default withRouter(connect(
    null,
    null
)(QuizReports));